import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const { userData, authLoading } = useSelector((state) => state.userReducer);
  const location = useLocation();

  // While auth check is running, render nothing (App already shows Loader)
  if (authLoading) return null;

  // Not authenticated → redirect to login
  if (!userData) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Authenticated → allow access
  return children;
};

export default ProtectedRoute;
